import { createVNode as _createVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/svg/info-success.svg'


const _hoisted_1 = { class: "px-5 w-full fixed bottom-10 left-0" }
const _hoisted_2 = { class: "bg-white shadow-modal px-6 py-4 w-full sm:w-3/4 lg:w-3/6 max-w-xl\n      flex items-center justify-between mx-auto" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  class: "mr-5 w-9",
  src: _imports_0,
  alt: "Success icon"
}, null, -1)
const _hoisted_5 = { class: "text-secondary-dark" }
const _hoisted_6 = { class: "sm:text-18 font-semibold mb-1" }
const _hoisted_7 = { class: "text-11 sm:text-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, _toDisplayString(_ctx.title), 1),
          _createVNode("div", _hoisted_7, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ])
      ]),
      _createVNode("div", {
        class: "cursor-pointer hover:opacity-50",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('hide')))
      }, [
        _createVNode(_component_font_awesome_icon, {
          class: "text-20 md:text-33 text-icon-light",
          icon: ['fas', 'times']
        })
      ])
    ])
  ]))
}